import { render } from "./EncycloBoard.vue?vue&type=template&id=0988e819"
import script from "./EncycloBoard.vue?vue&type=script&lang=js"
export * from "./EncycloBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__